import { MapPin, Phone } from 'lucide-react';
import type { PublicAppointmentActionLanding } from '@/features/okdoc/types';

interface ClinicContactsCardProps {
  landing: PublicAppointmentActionLanding;
  accentClassName: string;
}

export function ClinicContactsCard({ landing, accentClassName }: ClinicContactsCardProps) {
  if (!landing.clinic_address && !landing.clinic_phone && !landing.clinic_website) {
    return null;
  }

  return (
    <div className="mt-6 space-y-3 rounded-[28px] border border-slate-200 bg-white p-5 text-sm text-slate-500 shadow-[0_24px_60px_-36px_rgba(15,23,42,0.35)]">
      <div className="text-center">
        <p className="text-sm font-semibold text-slate-900">Контакты клиники</p>
      </div>
      {landing.clinic_phone && (
        <div className="flex items-center justify-center gap-2 rounded-2xl bg-slate-50 px-4 py-3">
          <Phone className="h-4 w-4" />
          <span>{landing.clinic_phone}</span>
        </div>
      )}
      {landing.clinic_address && (
        <div className="flex items-center justify-center gap-2 rounded-2xl bg-slate-50 px-4 py-3 text-center">
          <MapPin className="h-4 w-4 shrink-0" />
          <span>{landing.clinic_address}</span>
        </div>
      )}
      {landing.clinic_website && (
        <div className="rounded-2xl bg-slate-50 px-4 py-3 text-center">
          <a className={`font-medium ${accentClassName}`} href={landing.clinic_website} target="_blank" rel="noreferrer">
            {landing.clinic_website}
          </a>
        </div>
      )}
    </div>
  );
}
